import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Route } from "react-router-dom";
import "./App.css";
import TimelinePageAdo from "./timeline/AzureDevOps/TimelinePageAdo";
import { RequestProvider } from "./api/Azure/requestContainer";
import * as LocalConst from "./common/localVariableDoNotCheckIn";
import * as TimelineStore from "./utils/timelineStore";


class App extends Component {
  constructor(props) {
    super(props);
    const _authAdo_un = TimelineStore.getUsername();
    const _authAdo_pw = TimelineStore.getPassword();
    const _authAdo = {un: _authAdo_un ? _authAdo_un : "", pw: _authAdo_pw ? _authAdo_pw : ""};

    this.state = 
    { 
        authAdo:  { un: _authAdo ? _authAdo.un : LocalConst.authAdoUsername, pw: _authAdo ? _authAdo.pw :  LocalConst.authAdoPassword }
    };

    this.updateAuthAdo = this.updateAuthAdo.bind(this);
  }

  updateAuthAdo(auth) {
    const _authAdo = {un: auth.un, pw: auth.pw};
    TimelineStore.setUsername(_authAdo.un);
    TimelineStore.setPassword(_authAdo.pw);
    this.setState({ authAdo: _authAdo});
  }

  render() {
    return (
      <RequestProvider>  
        <Router>
          <Route
            path="/"
            exact
            render={(props) => <TimelinePageAdo auth={this.state.authAdo} updateAuth={this.updateAuthAdo} {...props} />}
            />
          <Route path="/ado" render={(props) => <TimelinePageAdo auth={this.state.authAdo} updateAuth={this.updateAuthAdo} {...props} />} />
        </Router>
      </RequestProvider>
    );
  }
}

export default App;
